import React from 'react'
import { useIntl } from 'react-intl'
import {
  Button,
  BUTTON_VARIANT_SECONDARY,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  MessageBox,
  MESSAGE_BOX_VARIANT_DANGER,
  SpacingVertical
} from 'mailup-web-components'
import './ModalCheckupABTest.scss'
import { useRecoilState } from 'recoil'
import { modalCheckupState } from '../../recoil/state/modals'
import BlockingCheck from './components/BlockingCheck/BlockingCheck'

import PropTypes from 'prop-types'

const ModalCheckupABTest = ({ startWhen, abTestMessages }) => {
  const intl = useIntl()

  const [{ show, checkupArrayResp, error }, setOpen] = useRecoilState(
    modalCheckupState
  )

  return (
    <Modal
      show={show}
      showClose
      closeOnOverlayClick
      onClose={() => setOpen(prev => ({ ...prev, show: false }))}
      data-mu-test='modal-checkup-message-abTest__modal-checkup-field'
      className='c-modal-check-up'
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.EmailCheckUp.ModalCheckUpKoAbTestTitle'
        })}
      />
      {error ? (
        <ModalBody>
          <MessageBox variant={MESSAGE_BOX_VARIANT_DANGER}>
            {intl.formatMessage({ id: 'Load.Alerts.ErrorGeneric' })}
          </MessageBox>
        </ModalBody>
      ) : (
        <ModalBody scrollable>
          <div className='c-modal-check-up__body'>
            <MessageBox variant={MESSAGE_BOX_VARIANT_DANGER}>
              {intl.formatMessage({
                id: 'Load.EmailCheckUp.ModalCheckUpKoAbTestDescr'
              })}
            </MessageBox>
            <SpacingVertical />
            <div className='c-modal-check-up__body__container'>
              {checkupArrayResp.map((e, index) => (
                <BlockingCheck
                  message={abTestMessages.find(
                    f => f.IdMessaggio === e.idMessage
                  )}
                  key={index}
                />
              ))}
            </div>
          </div>
        </ModalBody>
      )}
      <ModalFoot>
        <Button
          onClick={() => setOpen(prev => ({ ...prev, show: false }))}
          kind={BUTTON_VARIANT_SECONDARY}
          data-mu-test='modal-checkup-message-abTest__modal-checkup-button-close'
        >
          {intl.formatMessage({ id: 'Load.Common.Close' })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

ModalCheckupABTest.propTypes = {
  abTestMessages: PropTypes.array,
  startWhen: PropTypes.bool
}

export default ModalCheckupABTest
